import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type UserRole = 'student' | 'teacher' | 'parent' | 'merchant';

export interface Profile {
  id: string;
  name: string;
  role: UserRole;
  phone: string;
  grade: string;
  region: string;
  avatar_url: string;
  bio: string;
  created_at: string;
  updated_at: string;
}
